import { useEffect, useState, ChangeEvent } from "react";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";
import { IParticipants } from "../../../../config/interfaces";
import { useProjectsState } from "../../../../hooks/projectsInfo";
import CrewsTable from "./table";
import { concat } from "lodash";
import {
  CallSheetParticipantInput,
  useGetParticipantsForCallSheetQuery,
} from "../../../../../graphql/generated/graphql";
import {
  setParticipantsCallSheet,
  useCallSheetState,
  setUnSavedCallSheet,
} from "../../../../hooks/callSheet";

import "./index.scss";

const CrewCallSheet = ({ assigned }: any) => {
  const projectsState = useProjectsState();
  const callSheetState = useCallSheetState();
  const currentProject = projectsState.projectId.get() || "";
  const [checkedAll, setCheckedAll] = useState(true);
  const [crews, setCrews] = useState<Array<IParticipants>>([]);
  const [participantsTable, setParticipantsTable] = useState<
    Array<IParticipants>
  >([]);
  const unsavedFlag = callSheetState.unsaved.get();

  const {
    data: participants,
    loading,
    error,
  } = useGetParticipantsForCallSheetQuery({
    variables: {
      name_or_email: "",
      project_id: currentProject,
    },
  });

  useEffect(() => {
    if (participants) {
      setCrews(
        participants.getParticipantsForCallSheet as Array<IParticipants>
      );
    }
  }, [participants]);

  const updateParticipants = (
    participantArray: CallSheetParticipantInput[],
    deleteValue = false,
    update = false
  ) => {
    const currentTime = callSheetState.time.get();
    let tempParticipants: CallSheetParticipantInput[] =
      callSheetState.participant.get().map((n) => ({
        email: n.email,
        id: n.id,
        time: n.time,
      }));
    participantArray.forEach((element: CallSheetParticipantInput) => {
      const selectedIndex = tempParticipants.findIndex(
        (x) => x.id === element.id
      );
      if (tempParticipants[selectedIndex]) {
        if (tempParticipants[selectedIndex].time == currentTime) {
          if (!unsavedFlag) setUnSavedCallSheet(true);
        }
      }
      if (deleteValue) {
        if (selectedIndex === 0) {
          tempParticipants = tempParticipants.slice(1);
        } else if (selectedIndex === tempParticipants.length - 1) {
          tempParticipants = tempParticipants.slice(0, -1);
        } else if (selectedIndex > 0) {
          tempParticipants = concat(
            tempParticipants.slice(0, selectedIndex),
            tempParticipants.slice(selectedIndex + 1)
          );
        }
      } else if (selectedIndex >= 0) {
        tempParticipants[selectedIndex] = element;
      } else if (selectedIndex < 0) {
        tempParticipants.push(element);
      }
    });
    if (update) {
      const usersUpdate: any = [];
      assigned.map((e: any) => {
        return e.users.map((ele: any) => {
          if (ele.assigned_in_call_sheet) usersUpdate.push(ele.email);
        });
      });
      const filterUsers = tempParticipants.filter((prson: any) =>
        usersUpdate.includes(prson.email)
      );
      setParticipantsCallSheet(filterUsers);
    } else {
      setParticipantsCallSheet(tempParticipants);
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    setCheckedAll(event.target.checked);
  };

  return (
    <>
      {!error && crews.length > 0 && (
        <>
          <Grid
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
            }}
            className="crew-checkbox"
          >
            <FormControlLabel
              value="selectAll"
              control={
                <Checkbox
                  checked={checkedAll}
                  onChange={handleChange}
                />
              }
              label="Select All"
              labelPlacement="start"
            />
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {crews.map((item: IParticipants) => {
              return (
                <CrewsTable
                  key={item.name}
                  name={item.name}
                  title={item.title}
                  users={item.users}
                  time={callSheetState.time.get()}
                  selected={checkedAll}
                  sendSelected={updateParticipants}
                  assigned={assigned}
                />
              );
            })}
          </Grid>
        </>
      )}
    </>
  );
};

export default CrewCallSheet;
